export default __webpack_public_path__ + "images/2b0129429842dee6cfd86f4685fa7958-valentine_dating_mobile.webp";